import Vue from 'vue'
import Router from 'vue-router'
import Launch from '@/pages/launch'
import PhoneNum from '@/pages/phone-num'
import SmsVerification from '@/pages/sms-verification'
import SmsProgram from '@/pages/sms-program'
import AgreeTerms from '@/pages/agree-terms'
import MemberCenter from '@/pages/member-center'
import MemberScan from '@/pages/member-scan'
import LoanHistory from '@/pages/loan-history'
import HistoricalOrder from '@/pages/historical-order'
import AppointmentOnline from '@/pages/appointment-online'
import OrderContent from '@/pages/order-content'
import ReservePage from '@/pages/reserve-page'
import ReserveSpeople from '@/pages/reserve-select-people'
import ReserveSMaintype from '@/pages/reserve-select-main-type'
import ReserveSSubtype from '@/pages/reserve-select-sub-type'
import ReserveDateTime from '@/pages/reserve-datetime'
import TrialCalculation from '@/pages/trial-calculation'
import ReservationNotes from '@/pages/reservation-notes'

Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    // 主畫面
    {
      path: '/',
      name: 'launch',
      component: Launch
    },
    // 功能傳入頁面
    {
      path: '/wb/:liffId/:actionType',
      name: 'launch-action',
      component: Launch
    },
    // 輸入電話頁
    {
      path: '/phone-num',
      name: 'phoneNum',
      component: PhoneNum
    },
    // 簡訊驗證
    {
      path: '/sms-verification',
      name: 'SmsVerification',
      component: SmsVerification
    },
    // 變更姓名
    {
      path: '/change-name',
      name: 'ChangeName',
      component: SmsProgram
    },
    // 驗證程序
    {
      path: '/sms-program',
      name: 'SmsProgram',
      component: SmsProgram
    },
    // 同意條款
    {
      path: '/agree-terms',
      name: 'AgreeTerms',
      component: AgreeTerms
    },
    // 會員中心
    {
      path: '/member-center',
      name: 'MemberCenter',
      component: MemberCenter
    },
    // QRCode 掃描
    {
      path: '/member-scan',
      name: 'MemberScan',
      component: MemberScan
    },
    // 租借歷史
    {
      path: '/loan-history',
      name: 'LoanHistory',
      component: LoanHistory
    },
    // 歷史訂單資訊
    {
      path: '/historical-order',
      name: 'HistoricalOrder',
      component: HistoricalOrder
    },
    // 我要預約
    {
      path: '/appointment-online',
      name: 'AppointmentOnline',
      component: AppointmentOnline
    },
    // 預約內容
    {
      path: '/order-content',
      name: 'OrderContent',
      component: OrderContent
    },
    // 歡迎預約
    {
      path: '/reserve-page',
      name: 'ReservePage',
      component: ReservePage
    },
    // 預約車輛數
    {
      path: '/reserve-select-people',
      name: 'ReserveSpeople',
      component: ReserveSpeople
    },
    // 選擇主種類
    {
      path: '/reserve-select-main-type',
      name: 'ReserveStype',
      component: ReserveSMaintype
    },
    // 選擇子種類
    {
      path: '/reserve-select-sub-type',
      name: 'ReserveStype',
      component: ReserveSSubtype
    },
    // 小時預約
    {
      path: '/reserve-datetime',
      name: 'ReserveDateTime',
      component: ReserveDateTime
    },
    // 費用試算
    {
      path: '/trial-calculation',
      name: 'TrialCalculation',
      component: TrialCalculation
    },
    // 預約備註
    {
      path: '/reservation-notes',
      name: 'ReservationNotes',
      component: ReservationNotes
    }
  ]
})
